import { render, staticRenderFns } from "./SreportTemplate.vue?vue&type=template&id=c977518c&"
import script from "./SreportTemplate.vue?vue&type=script&lang=ts&"
export * from "./SreportTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports